import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage, setMessageStatus } from "./messages";

import adService from "../services/ad.service";


export const createAdNew = createAsyncThunk(
    "create/advertisements",
    async (inputs, thunkAPI) => {
        try {
            const data = await adService.saveAd(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const myAd = createAsyncThunk(
    "get/advertisements",
    async (inputs, thunkAPI) => {
        try {
            const data = await adService.adList(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const singleAd = createAsyncThunk(
    "get/advertisements-details",
    async (id, thunkAPI) => {
        try {
            const data = await adService.adDetails(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const deleteAd = createAsyncThunk(
    "get/advertisements-delete",
    async (id, thunkAPI) => {
        try {
            const data = await adService.adDelete(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const allAd = createAsyncThunk(
    "get/advertisements-allads",
    async (inputs, thunkAPI) => {
        try {
            const data = await adService.allAd(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const publicAd = createAsyncThunk(
    "get/advertisements-public",
    async (id, thunkAPI) => {
        try {
            const data = await adService.adPublic(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
const initialState = { advertisements: null, Status: "IDEL", advertisement: null, allads: null };

const jobsSlice = createSlice({
    name: "ads",
    initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: {
        [createAdNew.fulfilled]: (state, action) => {
            state.Status = "Success";
        },
        [createAdNew.rejected]: (state, action) => {
            state.Status = "Failed";
        },
        [myAd.fulfilled]: (state, action) => {
            state.advertisements = action.payload.user;
        },
        [myAd.rejected]: (state, action) => {
            state.Status = "Failed";
            state.advertisements = null;
        },

        [singleAd.fulfilled]: (state, action) => {
            state.advertisement = action.payload.user;
        },
        [singleAd.rejected]: (state, action) => {
            state.Status = "Failed";
            state.advertisement = null;
        },
        [allAd.fulfilled]: (state, action) => {
            state.allads = null;
            state.allads = action.payload.user;
        },
        [allAd.rejected]: (state, action) => {
            state.Status = "Failed";
            state.allads = null;
        },
        [publicAd.fulfilled]: (state, action) => {
            state.advertisement = action.payload.user;
        },
        [publicAd.rejected]: (state, action) => {
            state.Status = "Failed";
            state.advertisement = null;
        },

    },
});

const { reducer } = jobsSlice;
export default reducer;
